const subjectAdditionalInfo = (xmlElement) => {
    const root = xmlElement.getElementsByTagName("cb:SubjectAdditionalInfo");

    const SubjectAdditionalInfo = Array.from(root).map(element => {
        const AdditionalInfoCategoryCode = element.attributes?.AdditionalInfoCategoryCode?.value ?? ''
        const AdditionalInfoCategoryDesc = element.attributes?.AdditionalInfoCategoryDesc?.value ?? ''
        const AdditionalInformationNo = element.attributes?.AdditionalInformationNo?.value ?? ''
        const ProviderTypeCode = element.attributes?.ProviderTypeCode?.value ?? ''
        const ProviderTypeCodeDesc = element.attributes?.ProviderTypeCodeDesc?.value ?? ''
        const ProviderCode = element.attributes?.ProviderCode?.value ?? ''
        const ProviderCodeDesc = element.attributes?.ProviderCodeDesc?.value ?? ''
        const BranchCode = element.attributes?.BranchCode?.value ?? ''

        const AdditionalInfoDetails = Array.from(element.getElementsByTagName('cb:AdditionalInfoDetails')).map(elementChild => {
            const AdditionalInformationType = elementChild.attributes?.AdditionalInformationType?.value ?? ''
            const AdditionalInformationTypeDesc = elementChild.attributes?.AdditionalInformationTypeDesc?.value ?? ''
            const AdditionalInformationValue = elementChild.attributes?.AdditionalInformationValue?.value ?? ''
            const StatusCode = elementChild.attributes?.StatusCode?.value ?? ''
            const StatusDesc = elementChild.attributes?.StatusDesc?.value ?? ''
            const StatusDate = elementChild.attributes?.StatusDate?.value ?? ''
            const ReferenceDate = elementChild.attributes?.ReferenceDate?.value ?? ''

            return { AdditionalInformationType, AdditionalInformationTypeDesc, AdditionalInformationValue, StatusCode, StatusDesc, StatusDate, ReferenceDate }
        });

        return { AdditionalInfoCategoryCode, AdditionalInfoCategoryDesc, AdditionalInformationNo, ProviderTypeCode, ProviderTypeCodeDesc, ProviderCode, ProviderCodeDesc, BranchCode, AdditionalInfoDetails }
    })

    return { SubjectAdditionalInfo };
}

export default subjectAdditionalInfo;